import {Component, Input, OnChanges} from '@angular/core';
import {LoaderService} from '../../../../services/loader.service';
import {GlobalErrorHandlerService} from '../../../../services/global-error.service';
import {PatientService} from '../../../../services/patient.service';
import {ProgramEnrollment} from '../../../../program/eligible-patient';
import {UserService} from '../../../../services/user.service';

@Component({
  selector: 'app-patient-programs',
  templateUrl: './patient-programs.component.html',
  styleUrls: ['./patient-programs.component.scss']
})
export class PatientProgramsComponent implements OnChanges {
  @Input() patient;
  public request_type;
  public selected_program_enrolment: ProgramEnrollment;
  public patient_program_enrollments: ProgramEnrollment[] = [];
  public selectedProgram: ProgramEnrollment;

  constructor(public patientService: PatientService, public loaderService: LoaderService,
              public globalErrorHandlerService: GlobalErrorHandlerService, public userService: UserService) { }

  ngOnChanges() {
    this.getPatientProgram();
  }

  getPatientProgram() {
    this.loaderService.show();
    this.patientService.getPatientEnrolledPrograms(this.patient.id).then(resp => {
      this.patient_program_enrollments = resp.map(program => new ProgramEnrollment().load_from_json(program));
      this.loaderService.hide();
    }).catch(resp => {
      this.loaderService.hide();
      this.globalErrorHandlerService.error = resp.error.error;
    });
  }

  requestToCareTeam(type: string) {
    if (type == 'Opt Out') {
      this.sendOptOutRequest();
    } else {
      this.sendCallrequest(type);
    }
  }

  private sendOptOutRequest() {
    this.loaderService.show();
    this.patientService.sendOptOutRequestToProgramCareTeam(this.selected_program_enrolment.id).then( resp => {
      this.request_type = undefined;
      this.selected_program_enrolment = undefined;
      this.loaderService.hide();
    }).catch(resp => {
      this.loaderService.hide();
      this.globalErrorHandlerService.error = resp.error.error;
    });
  }

  private sendCallrequest(type: string) {
    this.loaderService.show();
    this.patientService.sendCallRequestToProgramCareTeam({id: this.selected_program_enrolment.id, call_type: type}).then( resp => {
      this.request_type = undefined;
      this.selected_program_enrolment = undefined;
      this.loaderService.hide();
    }).catch(resp => {
      this.loaderService.hide();
      this.globalErrorHandlerService.error = resp.error.error;
    });
  }

}
